module.exports = require("@nrwl/workspace/src/utils/ast-utils");